module.exports = __webpack_public_path__ + "img/hr-level1_running.cd7ddae5.png";